<template>
  <w-icon-wrapper icon-name="work-rotate-icon">
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rechteck_4038"
          data-name="Rechteck 4038"
          width="23.734"
          height="24.018"
          transform="translate(0 0)"
          fill="none"
        />
      </clipPath>
    </defs>
    <g
      id="_103_90_Grad_Icon"
      data-name="103_90 Grad_Icon"
      transform="translate(0 0)"
    >
      <g
        id="Gruppe_25452"
        data-name="Gruppe 25452"
      >
        <path
          id="Pfad_55806"
          data-name="Pfad 55806"
          d="M.3,9.355A12.02,12.02,0,0,1,14.657.3a12.166,12.166,0,0,1,1.8.558,11.851,11.851,0,0,1,3.925,2.569V1.487a1,1,0,0,1,2,0v5.2h-5.2a1,1,0,0,1,0-2h1.628a9.845,9.845,0,0,0-3.091-1.975,10.146,10.146,0,0,0-1.5-.465,10.008,10.008,0,1,0,7.543,11.969,1,1,0,1,1,1.95.442A12,12,0,0,1,1.854,18.412,11.928,11.928,0,0,1,.3,9.355"
          fill="currentColor"
        />
        <path
          id="Pfad_55807"
          data-name="Pfad 55807"
          d="M8.827,12.769a1.9,1.9,0,0,1-1.375.578,2.033,2.033,0,0,1-1.609-.69,2.731,2.731,0,0,1-.6-1.862,2.9,2.9,0,0,1,.326-1.366,2.392,2.392,0,0,1,.908-.969,2.523,2.523,0,0,1,1.313-.346,2.407,2.407,0,0,1,1.332.375,2.461,2.461,0,0,1,.906,1.078,3.844,3.844,0,0,1,.328,1.608v.558a4.386,4.386,0,0,1-.942,2.978,3.565,3.565,0,0,1-2.671,1.156l-.37.005V14.617l.334,0a1.924,1.924,0,0,0,2.124-1.843m-1-.573a1.05,1.05,0,0,0,.627-.187,1.255,1.255,0,0,0,.4-.453v-.62a2.064,2.064,0,0,0-.292-1.187.905.905,0,0,0-.781-.422.877.877,0,0,0-.744.414,1.756,1.756,0,0,0-.292,1.039A1.715,1.715,0,0,0,7.023,11.8a.924.924,0,0,0,.8.4"
          fill="currentColor"
        />
        <path
          id="Pfad_55808"
          data-name="Pfad 55808"
          d="M16.528,12.665a3.841,3.841,0,0,1-.651,2.406,2.273,2.273,0,0,1-1.906.833,2.287,2.287,0,0,1-1.895-.818,3.734,3.734,0,0,1-.672-2.343v-1.4a3.792,3.792,0,0,1,.659-2.411,2.29,2.29,0,0,1,1.9-.822,2.29,2.29,0,0,1,1.895.814,3.726,3.726,0,0,1,.672,2.341Zm-1.505-1.534a2.78,2.78,0,0,0-.258-1.374.871.871,0,0,0-.8-.429.858.858,0,0,0-.784.408,2.6,2.6,0,0,0-.268,1.28v1.845a2.907,2.907,0,0,0,.253,1.379.858.858,0,0,0,.809.451.846.846,0,0,0,.8-.432,2.852,2.852,0,0,0,.255-1.325Z"
          fill="currentColor"
        />
        <path
          id="Pfad_55809"
          data-name="Pfad 55809"
          d="M17.684,9.551A1.38,1.38,0,0,1,18.1,8.536a1.36,1.36,0,0,1,1-.422,1.33,1.33,0,0,1,.98.419,1.392,1.392,0,0,1,.414,1.018A1.405,1.405,0,0,1,19.1,10.968a1.386,1.386,0,0,1-.989-.409,1.339,1.339,0,0,1-.427-1.008M19.1,10.2a.614.614,0,0,0,.456-.185.641.641,0,0,0,.178-.461.68.68,0,0,0-.178-.468.592.592,0,0,0-.456-.2.614.614,0,0,0-.464.2.658.658,0,0,0-.188.468.62.62,0,0,0,.191.459.632.632,0,0,0,.461.187"
          fill="currentColor"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconRotate' };
</script>
